import { IconButton, withStyles } from '@material-ui/core';
import { ImageOutlined } from '@material-ui/icons';
import StyledToolTip from '../../../../common/StyledToolTip';
import CloseIcon from '@material-ui/icons/Close';

const styles = (theme) => ({
  mainContainer: {
    color: theme.HeaderSelectedText,
    fontWeight: 600,
    fontSize: theme.headerTextFontSize,
    padding: 16,
    borderBottom: `1px solid ${theme.AppBGColor}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  detailsContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  closeButton: {
    padding: 0,
    color: theme.iconColor
  },
  imageButton: {
    padding: 0,
    color: theme.palette.primary.main
  },
  proNumber: {
    marginLeft: 4
  },
  imageIconContainer: {
    marginLeft: 8
  }
});
const Header = ({ onClose, classes, proNumber, onViewStopImages, hideViewProImages }) => {
  return (
    <div className={classes.mainContainer}>
      <div className={classes.detailsContainer}>
        <div>Pro Information | </div>
        <div className={classes.proNumber}>{proNumber}</div>
        {!hideViewProImages && (
          <div className={classes.imageIconContainer}>
            <StyledToolTip title="View pro images">
              <IconButton
                aria-label="View pro images"
                className={classes.imageButton}
                onClick={onViewStopImages}>
                <ImageOutlined />
              </IconButton>
            </StyledToolTip>
          </div>
        )}
      </div>
      <div>
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
    </div>
  );
};

export default withStyles(styles)(Header);
